<template>
  <div
    class="jump_dropdown-wrap"
    @mouseover="showMore = true"
    @mouseleave="showMore = false"
  >
    <div class="more-menu">
      <div>
        <span>AIGC</span>
        <img class="star star_left" src="@/assets/image/jump/icon-star-red.png" alt="">
        <img class="star star_right" src="@/assets/image/jump/icon-star-red.png" alt="">
        <img class="star star_top" src="@/assets/image/jump/icon-star-red.png" alt="">
      </div>
    </div>
    <div class="check-menu" v-if="showMore || $route.path == '/aiVoice'"></div>
    <div
      class="content"
      :class="{ 'content-show': showMore }"
      @mouseover="showMore = true"
      @mouseleave="showMore = false"
    >
      <div
        class="menu-item"
        v-for="item in menu"
        :key="item.key"
        @mouseover="mouseOver(item.key)"
        @mouseleave="mouseLeave(item.key)"
        @click="handleSwitch(item.url)"
      >
        <div class="img-wrap">
          <img :src="require(`@/assets/image/jump/${item.img}`)" alt="" />
        </div>
        <div>
          <p>{{item.title}}</p>
          <span>{{item.desc}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Jump',
  data() {
    return {
      showMore: false,
      menu: [{
        title: 'AI音乐',
        desc: '音乐梦想不再遥不可及',
        key: 'music',
        url: 'creative',
        img: 'ai_music.png'
      },{
        title: 'AI视频',
        desc: '让你的创意动起来',
        key: 'video',
        url: 'video',
        img: 'ai_video.jpg'
      },
      {
        title: 'AI图片',
        desc: '轻松实现创意图片',
        key: 'picture',
        url: 'picture',
        img: 'ai_picture.jpg'
      },
      {
        title: 'AI语音',
        desc: '一键生成有温度的语音',
        key: 'voice',
        url: '',
        img: 'ai_yuyin.jpg'
      }]
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo'
    })
  },
  methods: {
    handleMoreMenu(){
      // 移入更多菜单栏区域
      this.showMore = true
    },
    // 移入
    mouseOver() {
    },
    // 移出
    mouseLeave() {
    },
    handleSwitch(url) {
      this.showMore = false
      if(!this.userInfo) return this.$store.dispatch('user/openLogin')
      // AI语音跳转
      if(!url) {
        this.$router.push('/aiVoice')
        return
      }
      // window.name = this.userInfo.phone

      // window.location.href = `${process.env.VUE_APP_SUNO_URL}`
      let name = this.userInfo.phone || this.userInfo.email
      // console.log(name,'==name');
      window.open(`${process.env.VUE_APP_SUNO_URL}${url}`, name);
      // window.open(`http://192.168.2.18:3000/${url}`, name);

    }
  }
}
</script>
<style lang="scss" scope>
.jump_dropdown-wrap {
  margin-right: 8px;
  position: relative;
  .check-menu {
    position: absolute;
    width: 80px;
    height: 4px;
    background: #E52A0D;
    bottom: 2px;
    left: 0;
    // animation: checkIcon .2s;
  }
  .more-menu {
    padding: 0 24px;
    height: 62px;
    display: flex;
    align-items: center;
    position: relative;
    color: red;
    .star {
      position: absolute;
    }
    .star_left {
      width: 10px;
      height: 10px;
      top: 26px;
      left: 10px;
    }
    .star_right {
      width: 12px;
      height: 12px;
      top: 24px;
      right: 12px;
    }
    .star_top {
      width: 14px;
      height: 14px;
      top: 16px;
      left: 16px;
    }
  }
  .content {
    position: absolute;
    top: 60px;
    left: -114px;
    padding: 12px;
    background: #FFFFFF;
    flex-direction: column;
    align-items: center;
    border-radius: 0px 0px 4px 4px;
    display: none;
    .menu-item {
      cursor: pointer;
      padding: 6px 0;
      width: 268px;
      background: #FFFFFF;
      display: flex;
      align-items: center;
      .img-wrap {
        overflow: hidden;
        border-radius: 4px;
        width: 90px;
        height: 80px;
        margin-right: 16px;
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      div {
        p{
          font-size: 14px;
          font-weight: 600;
          color: #333333;
          margin-bottom: 2px;
        }
        span {
          font-size: 12px;
          color: #999999;
        }
      }
    }
    .menu-item:hover {
      background: #eee;
    }
  }
  .content-show {
    display: flex;
  }
}

</style>
